export const TAG_MODAL_TITLE = 'Tag'
export const TAG_MODAL_TITLE_NEW = 'New tag'
